import { DEFAULT_LANGUAGE_CODE } from 'utils/constants';
export function useLanguageCode() {
    return DEFAULT_LANGUAGE_CODE;
}
